// extracted by mini-css-extract-plugin
export default {"approval-type__input-tab--container":"styles_approval-type__input-tab--container__M+BeJ","change-host__host-account":"styles_change-host__host-account__chDae"};